export default {"src":"/org/_next/static/media/tooltip.cdc1aaa0.svg","height":12,"width":14,"blurWidth":0,"blurHeight":0};